module.exports = function(bootstrap) {
    bootstrap.run(['Service', function(Service) {
        new Service(
            {
                name: 'planProgressV3',
                group: 'rbsmbl',
                url: '/rbsmbl/x-services/plan/v3/progress',

                fetch: function() {
                    return this.get();
                }
            }
        );
    }]);
};